export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11813.511f62dd.jpg";